var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 479 479",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.5 59.3h-401C16.4 59.3 0 75.7 0 95.8v282.4c0 20.1 16.4 36.5 36.5 36.5h401c20.1 0 36.5-16.4 36.5-36.5V95.8c0-20.1-16.4-36.5-36.5-36.5zm-5.3 27L239.5 251.1 46.8 86.3h385.4zM447 378.2c0 5.2-4.3 9.5-9.5 9.5h-401c-5.2 0-9.5-4.3-9.5-9.5V104.9l203.7 174.2c.1.1.3.2.4.3.1.1.3.2.4.3.3.2.5.4.8.5.1.1.2.1.3.2l1.2.6c.1 0 .2.1.3.1.3.1.6.3 1 .4.1 0 .3.1.4.1.3.1.6.2.9.2.1 0 .3.1.4.1.3.1.7.1 1 .2h.3c.4 0 .9.1 1.3.1s.9 0 1.3-.1h.3c.3 0 .7-.1 1-.2.1 0 .3-.1.4-.1.3-.1.6-.2.9-.2.1 0 .3-.1.4-.1.3-.1.6-.2 1-.4.1 0 .2-.1.3-.1l1.2-.6c.1-.1.2-.1.3-.2.3-.2.5-.3.8-.5.1-.1.3-.2.4-.3.1-.1.3-.2.4-.3L447 109.2v269z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.584c5e0c78c4291bbe5be90c74e14abd.svg";
export { ForwardRef as ReactComponent };